module.exports = __webpack_public_path__ + "static/media/minus.805d4635.svg";